<div class="address-detail">
  <div class="row address-row">
    <div class="bill-to-add col-3 pl-0">
      <div class="content">
        <strong>{{ "orderCheckOut.billToAddress" | cxTranslate }}</strong>
        <address>
          <div class="name">
            {{ cartOrderReviewObj?.billToAddress?.firstName }}
            {{ cartOrderReviewObj?.billToAddress?.lastName }}
          </div>
          <div>{{ cartOrderReviewObj?.billToAddress?.companyName }}</div>
          <div>
            {{ cartOrderReviewObj?.billToAddress?.line1
            }}{{ cartOrderReviewObj?.billToAddress ? "," : " " }}
            {{ cartOrderReviewObj?.billToAddress?.line2
            }}{{ cartOrderReviewObj?.billToAddress?.line2 ? "," : " " }}
          </div>
          <div>
            {{ cartOrderReviewObj?.billToAddress?.town
            }}{{ cartOrderReviewObj?.billToAddress?.town ? "," : " " }}
            {{ cartOrderReviewObj?.billToAddress?.region?.name
            }}{{ cartOrderReviewObj?.billToAddress?.region?.name ? "," : " " }}
          </div>
          <div>
            {{ cartOrderReviewObj?.billToAddress?.country?.name
            }}{{ cartOrderReviewObj?.billToAddress?.country?.name ? "," : " " }}
            {{ cartOrderReviewObj?.billToAddress?.postalCode }}
          </div>
        </address>
      </div>
    </div>
    <div class="ship-to-add col-3">
      <div class="content">
        <strong>{{ "orderCheckOut.shipTo" | cxTranslate }}</strong>
        <address>
          <div class="name">
            {{ cartOrderReviewObj?.deliveryAddress?.firstName }}
            {{ cartOrderReviewObj?.deliveryAddress?.lastName }}
          </div>
          <div>
            {{ cartOrderReviewObj?.deliveryAddress?.companyName }}
          </div>
          <div>
            {{ cartOrderReviewObj?.deliveryAddress?.line1
            }}{{ cartOrderReviewObj?.deliveryAddress ? "," : " " }}
            {{ cartOrderReviewObj?.deliveryAddress?.line2
            }}{{ cartOrderReviewObj?.deliveryAddress?.line2 ? "," : " " }}
          </div>
          <div>
            {{ cartOrderReviewObj?.deliveryAddress?.town
            }}{{ cartOrderReviewObj?.deliveryAddress?.town ? "," : " " }}
            {{ cartOrderReviewObj?.deliveryAddress?.region?.name
            }}{{
              cartOrderReviewObj?.deliveryAddress?.region?.name ? "," : " "
            }}
          </div>
          <div>
            {{ cartOrderReviewObj?.deliveryAddress?.country?.name
            }}{{
              cartOrderReviewObj?.deliveryAddress?.country?.name ? "," : " "
            }}
            {{ cartOrderReviewObj?.deliveryAddress?.postalCode }}
          </div>
        </address>
      </div>
    </div>
    <div class="end-cust-add col-3">
      <div class="content">
        <strong>{{ "orderCheckOut.endCstmrAdd" | cxTranslate }}</strong>
        <address *ngIf="cartOrderReviewObj.rfqType !== 'STK'">
          <div class="name">
            {{ cartOrderReviewObj?.endUserAddress?.firstName }}
            {{ cartOrderReviewObj?.endUserAddress?.lastName }}
          </div>
          <div>
            {{ cartOrderReviewObj?.endUserAddress?.companyName }}
          </div>
          <div>
            {{ cartOrderReviewObj?.endUserAddress?.line1
            }}{{ cartOrderReviewObj?.endUserAddress ? "," : " " }}
            {{ cartOrderReviewObj?.endUserAddress?.line2
            }}{{ cartOrderReviewObj?.endUserAddress?.line2 ? "," : " " }}
          </div>
          <div>
            {{ cartOrderReviewObj?.endUserAddress?.town
            }}{{ cartOrderReviewObj?.endUserAddress?.town ? "," : " " }}
            {{ cartOrderReviewObj?.endUserAddress?.region?.name
            }}{{ cartOrderReviewObj?.endUserAddress?.region?.name ? "," : " " }}
          </div>
          <div>
            {{ cartOrderReviewObj?.endUserAddress?.country?.name
            }}{{
              cartOrderReviewObj?.endUserAddress?.country?.name ? "," : " "
            }}
            {{ cartOrderReviewObj?.endUserAddress?.postalCode }}
          </div>
        </address>

        <address *ngIf="cartOrderReviewObj.rfqType === 'STK'">
          <div class="name">
            {{ cartOrderReviewObj?.billToAddress?.firstName }}
            {{ cartOrderReviewObj?.billToAddress?.lastName }}
          </div>
          <div>{{ cartOrderReviewObj?.billToAddress?.companyName }}</div>
          <div>
            {{ cartOrderReviewObj?.billToAddress?.line1
            }}{{ cartOrderReviewObj?.billToAddress ? "," : " " }}
            {{ cartOrderReviewObj?.billToAddress?.line2
            }}{{ cartOrderReviewObj?.billToAddress?.line2 ? "," : " " }}
          </div>
          <div>
            {{ cartOrderReviewObj?.billToAddress?.town
            }}{{ cartOrderReviewObj?.billToAddress?.town ? "," : " " }}
            {{ cartOrderReviewObj?.billToAddress?.region?.name
            }}{{ cartOrderReviewObj?.billToAddress?.region?.name ? "," : " " }}
          </div>
          <div>
            {{ cartOrderReviewObj?.billToAddress?.country?.name
            }}{{ cartOrderReviewObj?.billToAddress?.country?.name ? "," : " " }}
            {{ cartOrderReviewObj?.billToAddress?.postalCode }}
          </div>
        </address>
        <div>
          <strong>{{ cartOrderReviewObj?.endUserIndustry }}</strong>
        </div>
      </div>
    </div>
  </div>
</div>
